import usePortalDashboard from "hooks/usePortalDashboard";
import { BiArrowToRight, BiHomeAlt, BiLibrary } from "react-icons/bi";
import { BsFillJournalBookmarkFill } from "react-icons/bs";
import { FcStatistics } from "react-icons/fc";
import { FiPackage } from "react-icons/fi";
import { RiAccountPinCircleLine } from "react-icons/ri";
import useAuthStore from "store/authStore";
import { Permission } from "utils/server-constants/permissions";
import { Role } from "utils/server-constants/roles";

const useNavigationLinks = () => {
	const isAuthenticated = useAuthStore((state) => state.loggedIn);
	const hasPermissions = useAuthStore((state) => state.hasPermissions);
	const hasRoles = useAuthStore((state) => state.hasRoles);
	const { dashboardUrl, canAccessPortal } = usePortalDashboard();

	/** @var {Array<{to: string, label: string, show: boolean, icon: React.ReactNode}>} menu */
	const menu = [
		{
			to: "/",
			label: "Home",
			show: true,
			icon: <BiHomeAlt />,
		},
		{
			to: "/books",
			label: "Books",
			show: true,
			icon: <BsFillJournalBookmarkFill />,
		},
		{
			to: "/subscriptions",
			label: "Subscribe",
			show: true,
			icon: <FiPackage />,
		},
		{
			to: "/my-library",
			label: "My Library",
			show: isAuthenticated,
			icon: <BiLibrary />,
		},

		{
			to: "/register",
			label: "Register",
			show: !isAuthenticated,
			icon: <RiAccountPinCircleLine />,
		},
		{
			to: "/login",
			label: "Login",
			show: !isAuthenticated,
			icon: <RiAccountPinCircleLine />,
		},
		{
			to: "/hlf-reports",
			label: "HLF",
			show:
				isAuthenticated &&
				(hasPermissions([Permission.ViewReportsForHLF]) ||
					hasRoles([Role.SuperAdmin])),
			icon: <FcStatistics />,
		},
		{
			to: `/${dashboardUrl}`,
			label: "Portal",
			show: isAuthenticated && canAccessPortal,
			icon: <BiArrowToRight />,
		},
	];

	return menu.filter((item) => item.show);
};

export default useNavigationLinks;
